$(document).ready(() => {
  $(".trigger-secondary:not(.next-level)").click(() => {
    $(this).hasClass("secondary-open")
      ? $(this).removeClass("secondary-open")
      : $(this).addClass("secondary-open");
  }),
    $(".trigger-tertiary").click(() => {
      $(this).hasClass("tertiary-open")
        ? $(this).removeClass("tertiary-open")
        : $(this).addClass("tertiary-open");
    }),
    $(".next-level").click(() => {
      $(this).hasClass("next-open")
        ? $(this).removeClass("next-open")
        : $(this).addClass("next-open");
      $(".mobile-menu-footer").hasClass("hide")
        ? $(".mobile-menu-footer").removeClass("hide")
        : $(".mobile-menu-footer").addClass("hide");
      $(".secondary-open").removeClass("secondary-open");
    }),
    $(".close-secondary").click(() => {
      $(this)
        .parent()
        .parent()
        .siblings(".next-level")
        .removeClass("next-open");
      $(".mobile-menu-footer").removeClass("hide");
    }),
    $("#menuToggle").click((event) => {
      event.preventDefault();
      $(".mobile-menu-container").addClass("open"),
        $(".mobile-menu").addClass("open"),
        $("html").css("overflow", "hidden"),
        $("body").css("overflow", "hidden");
    }),
    $(".mobile-menu .close-menu").click(() => {
      $(".mobile-menu").removeClass("open"),
        $(".mobile-menu-container").removeClass("open"),
        $("html").css("overflow", ""),
        $("body").css("overflow", "");
    });
});

function initSwiper(selector, options) {
  if (typeof Swiper === "undefined" || !document.querySelector(selector)) {
    return null;
  }

  return new Swiper(selector, options);
}


$(".link-container .double").parent().addClass("has-double");
var galleryThumbs = initSwiper(".gallery-thumbs", {
    spaceBetween: 11,
    slidesPerView: 6,
    breakpoints: {
      750: {
        direction: "vertical",
        spaceBetween: 1,
        centerInsufficientSlides: !1,
        slidesPerView: "auto",
      },
    },
  }),
  galleryTop = initSwiper(".gallery-top", {
    slidesPerView: 1,
    simulateTouch: !1,
    spaceBetween: 15,
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next.article-arrows",
      prevEl: ".swiper-button-prev.article-arrows",
    },
    breakpoints: {
      750: {
        direction: "vertical",
        slidesPerView: "auto",
        simulateTouch: "true",
        touchReleaseOnEdges: "true",
        autoHeight: false,
      },
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  }),
  matchingAccessories = initSwiper(".matching-accessories", {
    slidesPerView: 2,
    spaceBetween: 15,
    navigation: {
      nextEl: ".matching-accessories .swiper-button-next",
      prevEl: ".matching-accessories .swiper-button-prev",
    },
  });
function swatchDelay() {
  $(".swatchColor").each(function () {
    $(this).hasClass("currentSwatch") &&
      $(".selected-swatch").text(": " + this.textContent);
  }),
    $(".swatchColor").click(function () {
      $(".selected-swatch").text(": " + this.textContent);
    });
}

setTimeout(
  function () {
    initSwiper(".recommendations-swiper", {
      slidesPerView: 2.2,
      spaceBetween: 20,
      roundLengths: !0,
      breakpoints: {
        750: {
          slidesPerView: 3,
          simulateTouch: !1,
        },
        1024: {
          slidesPerView: 4,
          simulateTouch: !1,
        },
      },
    });
  },

  1e3
),
  $.fn.fancybox &&
    $('[data-fancybox="gallery"], .customer-style').fancybox({
      buttons: ["zoom", "close"],
    }),
  $(".swatch-container").each(function () {
    var e = $(this).find(".selected-option");
    var i = $(this).find(".swatch-element");
    var atc = $(".details-container form .atc");
    var atcText = $(".details-container form .atc span");
    $(i).click(function () {
      $(e).text(": " + this.textContent);
      if ($(this).hasClass("soldout")) {
        atc.addClass("disabled");
        atcText.text("SOLD OUT");
      } else {
        atc.removeClass("disabled");
        atcText.text("ADD TO CART");
      }
    });
  }),
  $(document).ready(function () {
    setTimeout(swatchDelay, 600),
      $(window)
        .bind("resize", function () {
          $(this).width() > 749 &&
            $.fn.stick_in_parent &&
            $(
              ".multiImage .gallery-thumbs, .details.multiImage"
            ).stick_in_parent({
              offset_top: 70,
            });
        })
        .trigger("resize");
  });
/*,
$(document).ready(function() {
    $(".animsition").animsition( {
        inClass: "fade-in", outClass: "fade-out", loading: !1, inDuration: 600, outDuration: 200, browser: ["animation-duration", "-webkit-animation-duration"]
    }
    ), console.log("ready")
}

);*/
